<div class="p-3" *ngIf="is_loading">
    <h3>Loading...</h3>
</div>
<div class="p-3" *ngIf="!is_loading">
    <h3>Agent Wallet</h3>
    <select class="form-control" name="type" #type="ngModel" [(ngModel)]="transaction.type" required>
        <optgroup label="Manual">
            <option [value]="'withdraw-commission'">Withdraw Commission</option>
            <option *ngIf="http.flattened_permission['agent-adjustment']" [value]="'commission-adjustment'">Commission Adjustment</option>
        </optgroup>
    </select>

    <ng-container *ngIf="transaction.type == 'withdraw-commission'">
        <div class="mb-3">
            <label for="bank" class="form-label">From Bank <em>*</em></label>
            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="transaction.bank" required>
                <option [value]="b.id" *ngFor="let b of banks;">{{b.title}} (RM {{b.balance}})</option>
            </select>
            <div *ngIf="bank.invalid" class="invalid-feedback">
                <div *ngIf="bank.errors.required">Bank is required</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="payment" class="form-label">Commission Payout <em>*</em></label>
            <input type="number" class="form-control" id="payment" name="payment" #payment="ngModel" [(ngModel)]="transaction.payment" required>
            <div *ngIf="payment.invalid" class="invalid-feedback">
                <div *ngIf="payment.errors.required">Commission Payout is required</div>
            </div>
        </div>

        <div class="mb-3">
            <hr/>
            <p>Select from customer account or manual fill in below</p>
            <label for="payout_account" class="form-label">Payout To Account</label>

            <select class="form-control" id="payout_account" name="payout_account" #payout_account="ngModel" [(ngModel)]="transaction.payout_account" >
                <option value="-">New Account</option>
                <option *ngFor="let bank of data.banks" [value]="bank.id">{{bank.bank}} - {{bank.account}}</option>
            </select>

            <div class="input-group mt-3" *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate">
                <div class="input-group-append flex-fill">
                    <div class="input-group-text">
                        <label class="me-2" for="finance_charge">Finance Charge</label>
                        <select [(ngModel)]="transaction.finance_charge" #fc="ngModel" id="finance_charge" name="finance_charge" (change)="fcRateChange()" required>
                            <option [value]="true">YES</option>
                            <option [value]="false">No</option>
                        </select>
                    </div>
                    <div *ngIf="fc.invalid" class="invalid-feedback">
                        <div *ngIf="fc.errors.required">Finance Charge is required</div>
                    </div>
                </div>
            </div>

            <div *ngIf="payout_account.invalid" class="invalid-feedback">
                <div *ngIf="payout_account.errors.required">Payout To Account is required</div>
            </div>

            <!-- <div class="mt-3" *ngIf="setting.enabled_finance_charge === 'true' && setting.finance_charge_rate && transaction.payment && transaction.finance_charge === 'true'">
                Final Bank Transaction:<br/>{{transaction.payment ?? 0}} + {{setting.finance_charge_rate}} = <span class="text-danger fw-bolder">{{(transaction.payment ?? 0) + setting.finance_charge_rate}}</span>
            </div> -->
            <hr *ngIf="transaction.payout_account == '-'" />
<!--                             
            <label for="payout_account" class="form-label">Payout To Account</label>
            <div class="input-group">
                <div class="input-group-append">
                  <div class="input-group-text">
                    <label class="me-2" for="fc">Finance Charge</label>
                    <input type="checkbox" id="fc" />
                </div>
                </div>
                <select class="form-control" id="payout_account" name="payout_account" #payout_account="ngModel" [(ngModel)]="transaction.payout_account" >
                    <option value="-">-</option>
                    <option *ngFor="let bank of data.banks" [value]="bank.id">{{bank.bank}} - {{bank.account}}</option>
                </select>
            </div>
            
            <div *ngIf="payout_account.invalid" class="invalid-feedback">
                <div *ngIf="payout_account.errors.required">Payout To Account is required</div>
            </div>
            <hr/>
            <p>Select from option above or manual fill in below</p> -->
        </div>
        <div class="mb-3" *ngIf="(transaction.payout_account == '-' && transaction.payout_account)">
            <label for="payment_bank" class="form-label">Payment to Bank</label>
            <input type="text" class="form-control" id="payment_bank" name="payment_bank" #payment_bank="ngModel" [(ngModel)]="transaction.payment_bank" >
            <div *ngIf="payment_bank.invalid" class="invalid-feedback">
                <div *ngIf="payment_bank.errors.required">Bank is required</div>
            </div>
        </div>
        <div class="mb-3" *ngIf="(transaction.payout_account == '-' && transaction.payout_account)">
            <label for="bank_account" class="form-label">Payment to Account</label>
            <input type="number" class="form-control" id="bank_account" name="bank_account" #bank_account="ngModel" [(ngModel)]="transaction.bank_account" >
            <div *ngIf="bank_account.invalid" class="invalid-feedback">
                <div *ngIf="bank_account.errors.required">Bank Account is required</div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="transaction.type == 'commission-adjustment' && http.flattened_permission['agent-adjustment']">
        <div class="mb-3">
            <label for="commission_value" class="form-label">Commission Value <em>*</em></label>
            <input type="number" class="form-control" id="commission_value" name="commission_value" #commission_value="ngModel" [(ngModel)]="transaction.commission_value" required>
            <div *ngIf="commission_value.invalid" class="invalid-feedback">
                <div *ngIf="commission_value.errors.required">Commission Value is required</div>
            </div>
        </div>

        <div class="mb-3">
            <label for="adjustment_type" class="form-label">Adjustment Type</label>
            <select class="form-control" id="adjustment_type" name="adjustment_type" #adjustment_type="ngModel" [(ngModel)]="transaction.adjustment_type" >
                <option value="add">Add Commission</option>
                <option value="deduct">Deduct Commission</option>
                <option value="balance">Set Commission Balance</option>
            </select>
        </div>

        <div class="mb-3">
            <label for="remark" class="form-label">Commission Remark <em>*</em></label>
            <input type="text" class="form-control" id="remark" name="remark" #remark="ngModel" [(ngModel)]="transaction.remark" required>
            <div *ngIf="remark.invalid" class="invalid-feedback">
                <div *ngIf="remark.errors.required">Adjustment Remark is required</div>
            </div>
        </div>
    </ng-container>

    <button class="btn btn-success w-100" (click)="save()">SAVE</button>
    <button class="btn btn-danger w-100 mt-3" (click)="close()">CANCEL</button>
</div>